module.exports = __webpack_public_path__ + "static/media/images.40a3bd3a.svg";